import { CR_API_ENDPOINTS } from '../constants';
import { RoofCondition } from '../types';
import { apiService } from './api.service';

class RoofConditionsService {
  async getAllRoofConditions(): Promise<RoofCondition[]> {
    return apiService.get<RoofCondition[]>(CR_API_ENDPOINTS.ROOF_CONDITIONS);
  }

  async getRoofConditionById(id: string): Promise<RoofCondition> {
    return apiService.get<RoofCondition>(`${CR_API_ENDPOINTS.ROOF_CONDITIONS}/${id}`);
  }

  async createRoofCondition(roofConditionData: {
    value: string;
  }): Promise<RoofCondition> {
    try {
      return await apiService.post<RoofCondition>(CR_API_ENDPOINTS.ROOF_CONDITIONS, roofConditionData);
    } catch (error) {
      throw new Error(`Failed to create roof condition: ${error}`);
    }
  }
}

export const roofConditionsService = new RoofConditionsService();